<template>
  <div>
    <div class="loading" v-if="isLoading == true">
      <div class="sk-three-bounce">
        <div class="sk-child sk-bounce1"></div>
        <div class="sk-child sk-bounce2"></div>
        <div class="sk-child sk-bounce3"></div>
      </div>
    </div>
    <b-row class="mb-3" v-if="$can('export')">
      <b-col class="d-flex align-items-center justify-content-start" sm>
        <b-dropdown
          id="dropdown-left"
          variant="success"
          class="my-2 mr-3"
          :disabled="isLoadingButton || !isParams"
        >
          <template #button-content>
            <div
              class="d-inline-flex sk-three-bounce custom-loading-bounce"
              v-if="isLoadingButton"
            >
              <div class="sk-child sk-bounce1"></div>
              <div class="sk-child sk-bounce2"></div>
              <div class="sk-child sk-bounce3"></div>
            </div>
            <span class="mr-2" v-else>Generate Report</span>
          </template>

          <b-dropdown-item @click="handleGenerate('CSV')">
            CSV
          </b-dropdown-item>
          <b-dropdown-item @click="handleGenerate('XLSX')">
            XLSX
          </b-dropdown-item>
        </b-dropdown>
        <b-badge class="badge-info-generate" v-show="count && count > 0">
          <p class="badge-info-count">
            {{ count }}
          </p>
          <p>
            <strong>Report is being processed,</strong> check the
            <router-link :to="{ name: 'Report Transaction History' }">
              Report Transaction History
            </router-link>
            menu periodically to download the file.
          </p>
        </b-badge>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col sm>
        <div>
          <b-form-group
            class="mb-3"
            label="Search By Type Transaction :"
            label-for="so"
          >
            <b-form-select
              id="so"
              v-model="type"
              :options="transactionTypeOptions"
            >
            </b-form-select>
          </b-form-group>
        </div>
      </b-col>
      <b-col sm>
        <div>
          <b-form-group
            class="mb-3"
            label="Search :"
            label-for="search"
            :description="'Searchable by ' + typeFilterLabel"
          >
            <b-input-group>
              <b-input-group-prepend>
                <b-dropdown :text="typeFilterLabel" v-model="typeFilter" variant="secondary">
                  <b-dropdown-item v-for="(item, index) in typeData" :key="index" @click="typeFilter = item.value">
                    {{ item.text }}
                  </b-dropdown-item>
                </b-dropdown>
              </b-input-group-prepend>
              <b-form-input
                id="search"
                type="search"
                v-model="filterText"
                :placeholder="'Search by ' + typeFilterLabel + '...'"
              >
              </b-form-input>
              <b-input-group-append>
                <b-button
                  variant="secondary"
                  @click="resetFilter"
                  type="button"
                >
                  Reset
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col sm>
        <div>
          <b-form-group 
            class="mb-3" 
            label="Date :" 
            label-for="daterange"
            :state="dateRangeState === false ? false : computedDateRequiredState"
          >
            <template #invalid-feedback>
              <span v-if="dateRangeState === false">
                The date range must be at least 1 hour
              </span>
              <span v-else-if="computedDateRequiredState === false">
                Date range is required when using transaction type filter without specific search
              </span>
            </template>
            <b-input-group>
              <b-input-group-prepend is-text>
                <i class="fa fa-calendar"></i>
              </b-input-group-prepend>
              <range-picker
                id="daterange"
                :start="startDate"
                :end="endDate"
                :type="'clear'"
                :disable="false"
                :autoUpdate="false"
                :timePicker="true"
                @picker="doDateFilter"
              ></range-picker>
              <b-input-group-append>
                <b-button
                  type="button"
                  variant="secondary"
                  @click="resetDateFilter"
                  >Reset</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col sm>
        <b-button
          :disabled="stateButton"
          :style="buttonStyle"
          class="mb-2"
          @click="doFilter"
        >
          Apply Filter
        </b-button>
        <p class="mb-3" :style="{ color: 'rgba(115, 129, 143, 1)' }">
          Click button 'Apply Filter' to apply the filter
        </p>
      </b-col>
    </b-row>
    <div v-if="isLoadingTable">
      <b-skeleton-table
        :rows="10"
        :columns="11"
        :table-props="{ bordered: true }"
      >
      </b-skeleton-table>
    </div>
    <vuetable
      v-else
      ref="vuetable"
      :api-mode="false"
      :fields="fields"
      :per-page="limit"
      :data-manager="dataManager"
      pagination-path="pagination"
      :no-data-template="isParams ? defaultTemplate : noDataTemplate"
    >
      <template slot="name-slot" slot-scope="prop">
        <router-link
          :to="onAction('view-user', prop.rowData, prop.rowIndex)"
          target="_blank"
          >{{ prop.rowData.name }} ({{ prop.rowData.email }})</router-link
        >
        <span></span>
      </template>
      <template slot="transaction_type-slot" slot-scope="prop">
        <span>{{ prop.rowData.transaction_type }}</span>
      </template>
      <template slot="invoice_number-slot" slot-scope="prop">
        <span>{{
          prop.rowData.invoice_number == null
            ? "-"
            : prop.rowData.invoice_number
        }}</span>
      </template>
      <template slot="description-slot" slot-scope="prop">
        <span>{{ prop.rowData.description }}</span>
      </template>
      <template slot="amount-slot" slot-scope="prop">
        <span>{{ prop.rowData.amount }} </span>
      </template>
      <template slot="idr_amount-slot" slot-scope="prop">
        <span>{{ prop.rowData.idr_amount }} </span>
      </template>
      <template slot="status-slot" slot-scope="prop">
        <span>{{ prop.rowData.status }} </span>
      </template>
      <template slot="buying_rate-slot" slot-scope="prop">
        <span>{{ prop.rowData.buying_rate }} </span>
      </template>
      <template slot="selling_rate-slot" slot-scope="prop">
        <span>{{ prop.rowData.selling_rate }} </span>
      </template>
      <template slot="source_type-slot" slot-scope="prop">
        <span>{{ prop.rowData.source_type }} </span>
      </template>
      <template slot="actions-slot" slot-scope="prop">
        <div class="custom-actions">
          <button
            :class="
              prop.rowData.is_promotion === true
                ? 'btn btn-primary'
                : 'btn btn-success'
            "
            @click="onAction('detail-item', prop.rowData)"
          >
            Detail
          </button>
        </div>
      </template>
    </vuetable>
    <div
      v-show="isParams"
      class="vuetable-pagination ui basic segment grid"
    >
      <div class="wrapper-pagination-custom">
        <div class="pagination-custom-info">
          <p>{{ this.paginationInfo }}</p>
        </div>
        <div class="pagination-custom-button">
          <button :disabled="current_page === 1" @click="doMovePage('first')">
            <i
              v-if="current_page === 1"
              class="fa fa-angle-double-left disabled"
            ></i>
            <i v-else class="fa fa-angle-double-left"></i>
          </button>
          <button :disabled="current_page === 1" @click="doMovePage('prev')">
            <i v-if="current_page === 1" class="fa fa-angle-left disabled"></i>
            <i v-else class="fa fa-angle-left"></i>
          </button>
          <div>{{ this.current_page }}</div>
          <button :disabled="data.length < 10" @click="doMovePage('next')">
            <i v-if="data.length < 10" class="fa fa-angle-right disabled"></i>
            <i v-else class="fa fa-angle-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import Vue from "vue";
import Vuetable from "vuetable-2/src/components/Vuetable";

Vue.use(Vuetable);

export default {
  components: {
    Vuetable
  },
  prop: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  data() {
    return {
      count: 0,
      page: 1,
      current_page: 1,
      limit: 10,
      data: [],
      startDate: "",
      endDate: "",
      startDateExport: "",
      endDateExport: "",
      organization: "",
      type: "",
      transactionTypeOptions: [
        { value: "", text: "Search Transacation By .." },
        { value: "Beli Emas", text: "Beli Emas" },
        { value: "Jual Emas", text: "Jual Emas" },
        { value: "Cetak Emas", text: "Cetak Emas" },
        { value: "Cetak Koin", text: "Cetak Koin" },
        { value: "Transfer", text: "Transfer" },
        { value: "Titip Emas", text: "Titip Emas" },
        { value: "Donation", text: "Donation" },
        { value: "Zakat", text: "Zakat" },
        { value: "army", text: "Army" },
        { value: "Hadiah Emas", text: "Hadiah Emas" },
        { value: "Panen Emas", text: "Panen Emas" },
        { value: "Rencana Emas", text: "Rencana Emas" },
        { value: "Jamimas", text: "Jamimas" },
        { value: "Amal", text: "Amal" },
      ],
      organizationOptions: [
        { value: "", text: "Select Organization" },
        { value: "P7Jb1VXLzpm69xv", text: "Lazisnu" },
        { value: "KQxz9YXazA14VEO", text: "NU" }
      ],
      partner: "",
      partnerOptions: [
        { value: "", text: "Select Partner" },
        { value: "RgdZl3QvR4X7BP0", text: "Ladara Emas" }, // Prod RgdZl3QvR4X7BP0 dev 6KBYX9YRgYXVWGr
        { value: "6ynW4Kp6dX8zNgq", text: "Finansialku" } // Prod 6ynW4Kp6dX8zNgq dev 6KBYX9kEL6pVWGr
      ],
      filterText: "",
      typeFilter: "email",
      typeData: [
        { value: "name", text: "Name" },
        { value: "email", text: "Email" },
        { value: "phone", text: "Phone" },
        { value: "invoice_number", text: "Invoice No" },
      ],
      dateRangeState: null,
      dateRequiredState: null,
      isLoading: false,
      isLoadingTable: false,
      isLoadingButton: false,
      paginationInfo: "",
      errors: {
        code: "",
        message: "",
        status: ""
      },
      apiUrl: process.env.VUE_APP_SECRET + process.env.VUE_APP_CONFIG + `golds`,
      HttpOptions: {
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      },
      sort: "gold_transaction.created_at|desc",
      sortOrder: [
        {
          field: "created_at",
          sortField: "gold_transaction.created_at",
          direction: "desc"
        }
      ],
      moreParams: {},
      fields: [
        {
          name: "created_at",
          // sortField: "gold_transaction.created_at",
          title: "Date"
        },
        {
          name: "name-slot",
          // sortField: "name",
          title: "User"
        },
        {
          name: "transaction_type-slot",
          title: "Transaction Type"
        },
        {
          name: "invoice_number-slot",
          title: "Invoice"
        },
        {
          name: "description-slot",
          title: "Description",
          width: "20%"
        },
        {
          name: "amount-slot",
          title: "Gold Amount"
        },
        {
          name: "idr_amount-slot",
          title: "IDR Amount"
        },
        {
          name: "status-slot",
          title: "Transaction Status"
        },
        {
          name: "buying_rate-slot",
          title: "Gold Buy Price"
        },
        {
          name: "selling_rate-slot",
          title: "Gold Sell Price"
        },
        {
          name: "source_type-slot",
          title: "Source Type"
        },
        {
          name: "actions-slot",
          title: "Actions",
          titleClass: "center aligned",
          dataClass: "center aligned"
        }
      ],
      noDataTemplate:
        '<div class="text-center d-flex align-items-center justify-content-center" style="height: 120px;"><p>Use filter to show your data.</p></div>',
      defaultTemplate:
        '<div class="text-center d-flex align-items-center justify-content-center flex-column" style="height: 120px;"><p><strong>No results found.</strong></p><p>Please adjust your filter or search keywords</p></div>',
    };
  },
  computed: {
    computedDateRequiredState() {
      // Check if date is required based on active filters
      const hasTypeFilter = this.type !== "";
      const dateRangeEmpty = [this.startDate, this.endDate].every((f) => f === "");
      const hasFreetextFilter = this.filterText !== "";
      
      // Rule 3: If freetext is filled, date is not required (overrides rule 1)
      if (hasFreetextFilter) {
        return null;
      }
      
      // Rule 1: Date is required when type filter is active without freetext
      if (hasTypeFilter && dateRangeEmpty) {
        return false; // Invalid state
      }
      
      return null; // Valid state
    },
    stateButton() {
      const allFiltersEmpty = [
        this.type, this.filterText, this.startDate, this.endDate
      ].every((f) => f === "")
      
      // Disable if all filters are empty
      if (allFiltersEmpty) return true;
      
      // Disable if there's a date range validation error
      if (this.dateRangeState === false) return true;
      
      // Check filter types
      const hasTypeFilter = this.type !== "";
      const hasDateFilter = this.startDate !== "" || this.endDate !== "";
      const hasFreetextFilter = this.filterText !== "";
      
      // Rule 2 & 3: If freetext is filled, date is not required
      if (hasFreetextFilter) {
        return false;
      }
      
      // Rule 1: If has type filter without freetext, date is required
      if (hasTypeFilter && !hasDateFilter) {
        return true;
      }
      
      return false;
    },
    buttonStyle() {
      return {
        background: !this.stateButton ? "#7565F6" : "#c8ced3",
        color: !this.stateButton ? "#FFFFFF" : "inherit"
      };
    },
    typeFilterLabel() {
      const found = this.typeData.find(function(t) { return t.value === this.typeFilter; }, this);
      return found ? found.text : this.typeFilter;
    },
    isParams() {
      const params =
        // eslint-disable-next-line no-unused-vars
        Object.entries(this.moreParams).filter(([key, value]) => value)
          .length == 0;

      return !params && !this.isLoadingTable;
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    data(newVal, oldVal) {
      if (
        this.$refs.vuetable &&
        typeof this.$refs.vuetable.refresh === "function"
      ) {
        this.$refs.vuetable.refresh();
      }
    }
  },
  methods: {
    onFetchNotification() {
      this.$http
        .get("report-transaction/on-process-count/gold")
        .then(response => {
          const countProgress = response.data.data.on_process_count;
          this.count = countProgress;
        })
        .catch(err => {
          this.handleLoadError(err);
        });
    },
    onFetch() {
      const newParams = Object.entries(this.moreParams)
        // eslint-disable-next-line no-unused-vars
        .filter(([_, value]) => value !== '' && value != null)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");
      this.isLoadingTable = true;
      this.data = [];
      this.$http
        .get(
          `golds?page=${this.page}&per_page=${this.limit}&${newParams}`
        )
        .then(response => {
          const datas = response.data.data;
          const datasCount = datas.length;
          const startIndex = (response.data.current_page - 1) * this.limit;
          const endIndex = Math.min(
            startIndex + this.limit,
            datasCount > 0 ? datasCount + startIndex : this.limit
          );

          this.data = datas;
          this.current_page = response.data.current_page;
          this.paginationInfo =
            datas.length > 0
              ? `Displaying ${startIndex + 1} to ${endIndex}`
              : "No relevant data";

          this.isLoadingTable = false;
        })
        .catch(err => {
          this.isLoadingTable = false;
          this.handleLoadError(err);
        });
    },
    dataManager(sortOrder, pagination) {
      let local = this.data;

      if (local.length < 1) return;

      if (sortOrder.length > 0) {
        const newSort = `${sortOrder[0].sortField}|${sortOrder[0].direction}`;

        if (this.sort !== newSort) {
          this.sort = newSort;
          this.onFetch();
        }
      }

      pagination = this.$refs.vuetable.makePagination(local.length, this.limit);

      let from = pagination.from - 1;
      let to = from + this.limit;

      return {
        pagination: pagination,
        data: _.slice(local, from, to)
      };
    },
    onAction(action, data) {
      if (action == "view-user") {
        return { name: "Detail End User", params: { id: btoa(data.userData) } };
      } else if (action == "detail-item") {
        const routeData = this.$router.resolve({
          name: "Detail Gold Transaction",
          params: { id: btoa(data.id) }
        });
        window.open(routeData.href, "_blank");
      }
    },
    npwpVal(value) {
      return value != null ? value : "-";
    },
    doFilter() {
      this.$events.$emit("apply-filter");
    },
    resetFilter() {
      this.filterText = "";
    },
    handleLoadError(error) {
      const code = error.response.data.meta.code;
      const message = error.response.data.meta.message;

      this.errors.code = code;
      this.errors.message = message;
      this.errors.status = code;
      this.isLoading = false;
      this.isLoadingTable = false;
      this.isLoadingButton = false;

      if (this.errors.code == 401) {
        this.$swal
          .fire(
            "Your session expired!",
            "Your session has expired. Please login again to access this page!",
            "error"
          )
          .then(() => {
            this.$router.push("/login");
          });
      } else if (this.errors.code == 403) {
        this.$router.push("/403");
      } else {
        this.$swal.fire("An error occured", message, "error").then(() => {
          this.$router.reload();
        });
      }
    },
    resetDateFilter() {
      this.startDate = "";
      this.endDate = "";
      this.dateRangeState = null;
      // this.$events.$emit("date-filter-reset");
    },
    allcap(value) {
      return value.toUpperCase();
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet() {
      this.page = 1;
      this.moreParams = {
        start_from: this.startDate,
        end_to: this.endDate,
        ...(this.filterText && { typeFilter: this.typeFilter }),
        filter: encodeURIComponent(this.filterText),
        type: this.type
      };
      this.onFetch();
    },
    doDateFilter(value) {
      this.$events.$emit("date-set", value);
    },
    onDateSet(value) {
      const startDate = moment(value.startDate);
      const endDate = moment(value.endDate);
      
      // Calculate the difference in hours (with decimal precision)
      const hoursDiff = endDate.diff(startDate, 'hours', true);
      
      // Must be at least 1 hour difference
      if (hoursDiff < 1) {
        this.dateRangeState = false;
        return;
      }
      
      // Valid range - at least 1 hour
      this.dateRangeState = null;
      this.startDate = startDate.format("YYYY-MM-DD HH:mm");
      this.endDate = endDate.format("YYYY-MM-DD HH:mm");
    },
    doMovePage(value) {
      this.$events.$emit("movePage", value);
    },
    onMovePage(eventData) {
      if (eventData === "first") {
        this.page = 1;
        this.onFetch();
      } else if (eventData === "prev") {
        this.page--;
        this.onFetch();
      } else {
        this.page++;
        this.onFetch();
      }
    },
    handleGenerate(ext) {
      this.isLoadingButton = true;
      const newParams = Object.entries(this.moreParams)
        // eslint-disable-next-line no-unused-vars
        .filter(([_, value]) => value !== '' && value != null)
        .map(
          ([key, value]) =>
            `${
              key == "start_from"
                ? "startDate"
                : key == "end_to"
                ? "endDate"
                : key
            }=${value}`
        )
        .join("&");

      this.$http
        .get(
          `transaction/gold-all?fileFormat=${ext.toLowerCase()}${newParams ? `&${newParams}` : ""}`
        )
        .then(result => {
          const countProgress = result.data.meta.data.on_process_count;
          this.count = countProgress;
          this.isLoadingButton = false;
        })
        .catch(error => {
          this.handleLoadError(error);
        });
    },
    onDateFilterReset() {
      this.moreParams = Object.fromEntries(
        Object.entries(this.moreParams).filter(([key, value]) => {
          return [key, key !== "start_from" && key !== "end_to" ? value : ""];
        })
      );
    },
  },
  created() {
    this.onFetchNotification();

    this.$events.$on("apply-filter", this.onFilterSet);
    this.$events.$on("date-set", this.onDateSet);
    this.$events.$on("movePage", this.onMovePage);
    this.$events.$on("date-filter-reset", this.onDateFilterReset);
  },
  beforeDestroy() {
    this.$events.$off("apply-filter", this.onFilterSet);
    this.$events.$off("date-set", this.onDateSet);
    this.$events.$off("movePage", this.onMovePage);
    this.$events.$off("date-filter-reset", this.onDateFilterReset);
  }
};
</script>
<style>
/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.loading:before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}

.wrapper-pagination-custom {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f9fafb;
}

.pagination-custom-button {
  display: flex;
}

.pagination-custom-button button {
  width: 28px;
  height: 47px;
  padding: 13px 16px;
  font-size: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border: solid rgba(0, 0, 0, 0.3);
}

.pagination-custom-button button:first-child {
  padding: 13px 16px 13px 30px;
  border-radius: 4px 0 0 4px;
  border-width: 1px 0 1px 1px;
}

.pagination-custom-button button:nth-child(2),
.pagination-custom-button button:last-child {
  font-size: 1.3em;
  border-width: 1px;
}

.pagination-custom-button button:last-child {
  border-radius: 0 4px 4px 0;
}

.pagination-custom-button button i.disabled {
  opacity: 0.6;
}

.pagination-custom-button div {
  width: 28px;
  height: 47px;
  font-size: 1em;
  font-weight: 500;
  background: #ffffff;
  border: solid rgba(0, 0, 0, 0.3);
  border-width: 1px 0 1px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.badge-info-generate {
  height: 32px;
  padding: 8px 12px;
  background-color: #fff3d3;
  border-radius: 4px;
  font-size: 12px;
  font-weight: normal;
  display: flex;
  align-items: center;
  justify-content: center;
}

.badge-info-count {
  width: 18px;
  height: 18px;
  margin: 0 6px 0 0;
  background-color: #ffce50;
  border-radius: 100px;
}

.custom-loading-bounce {
  width: 72px !important;
  height: 18px !important;
  margin: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.custom-loading-bounce .sk-child {
  width: 6px !important;
  height: 6px !important;
  background: #ffffff !important;
}
</style>
<style src="spinkit/scss/spinkit.scss" lang="scss" />
